export const FEATURE_FLAG_NAMES = {
    ACCESS: 'access',
    ADD_ONS: 'add_ons',
    ADOPT_1_0_COMPANY: 'adopt_1_0_company',
    ADOPT_1_0_CONTENT_CLOUD: 'adopt_1_0_content_cloud',
    ADOPT_1_0_SMART_PAGES: 'adopt_1_0_smart_pages',
    ADOPT_1_0_SPLIT_SCREEN: 'adopt_1_0_split_screen',
    ADOPT_1_0_SYSTEM: 'adopt_1_0_system',
    ADOPT_1_0_TOOLTIPS: 'adopt_1_0_tooltips',
    ANALYTICS_CONSOLE: 'analytics_console',
    APPLICATION_LIST: 'application_list',
    APPLICATION_STATUS_TOGGLE: 'application_status_toggle',
    ARTICLES: 'articles',
    AUDIENCE: 'audience',
    COLLECTORS: 'collectors',
    CONFUSION: 'confusion',
    CONSOLE_LANGUAGE: 'console_language',
    CONTENT_LANGUAGE: 'content_language',
    CONTEXT_HELP: 'context_help',
    EXTENSION_URLS: 'extension_urls',
    FINARFIN_ANALYTICS_CONSOLE: 'finarfin_analytics_console',
    GUIDES: 'guides',
    GUIDE_DEFAULTS: 'guide_defaults',
    GUIDE_LIST: 'guide_list',
    CONTEXT_HELP_COMPOSITION: 'context_help_composition',
    IDENTITY: 'identity',
    INTEGRATIONS: 'integrations',
    JOURNEYS: 'journeys',
    LANGUAGE: 'language',
    LAYOUT_LIMITS: 'layout_limits',
    MEDIA_URL: 'media_url',
    MULTI_TENANCY: 'multi_tenancy',
    NOTIFICATIONS: 'notifications',
    OPEN_EDITOR: 'open_editor',
    OVERLAY_ENCAPSULATION: 'overlay_encapsulation',
    PLAYLISTS: 'playlists',
    PLAYLIST_CONSOLE_ADMIN: 'playlist_console_admin',
    PROFILE: 'profile',
    PROFILE_RULES: 'profile_rules',
    PROGRESS_TRACKER: 'progress_tracker',
    RECOMMENDATION: 'recommendation',
    RECORDING: 'recording',
    SEGMENTS: 'segments',
    SELECTOR_SYSTEM: 'selector_system',
    SETTINGS: 'settings',
    THEME: 'theme',
    THEME_BUILDER: 'theme_builder',
    TOOLTIPS: 'tooltips',
    TOOLTIPS_2: 'tooltips_2',
    TOUR: 'tour',
    TRACKING: 'tracking',
} as const;

type Values<Type> = Type[keyof Type];
export type FeatureFlagNamesType = Values<typeof FEATURE_FLAG_NAMES>;

export type FeatureFlags = Record<FeatureFlagNamesType, boolean>;

export const FEATURE_FLAGS_FROM_STATE: FeatureFlags = {
    [FEATURE_FLAG_NAMES.ACCESS]: false,
    [FEATURE_FLAG_NAMES.ADD_ONS]: false,
    [FEATURE_FLAG_NAMES.ADOPT_1_0_COMPANY]: false,
    [FEATURE_FLAG_NAMES.ADOPT_1_0_CONTENT_CLOUD]: false,
    [FEATURE_FLAG_NAMES.ADOPT_1_0_SMART_PAGES]: false,
    [FEATURE_FLAG_NAMES.ADOPT_1_0_SPLIT_SCREEN]: false,
    [FEATURE_FLAG_NAMES.ADOPT_1_0_SYSTEM]: false,
    [FEATURE_FLAG_NAMES.ADOPT_1_0_TOOLTIPS]: false,
    [FEATURE_FLAG_NAMES.ANALYTICS_CONSOLE]: false,
    [FEATURE_FLAG_NAMES.APPLICATION_LIST]: false,
    [FEATURE_FLAG_NAMES.APPLICATION_STATUS_TOGGLE]: false,
    [FEATURE_FLAG_NAMES.ARTICLES]: false,
    [FEATURE_FLAG_NAMES.AUDIENCE]: false,
    [FEATURE_FLAG_NAMES.COLLECTORS]: false,
    [FEATURE_FLAG_NAMES.CONFUSION]: false,
    [FEATURE_FLAG_NAMES.CONSOLE_LANGUAGE]: false,
    [FEATURE_FLAG_NAMES.CONTENT_LANGUAGE]: false,
    [FEATURE_FLAG_NAMES.CONTEXT_HELP]: false,
    [FEATURE_FLAG_NAMES.CONTEXT_HELP_COMPOSITION]: false,
    [FEATURE_FLAG_NAMES.EXTENSION_URLS]: false,
    [FEATURE_FLAG_NAMES.FINARFIN_ANALYTICS_CONSOLE]: false,
    [FEATURE_FLAG_NAMES.GUIDES]: false,
    [FEATURE_FLAG_NAMES.GUIDE_DEFAULTS]: false,
    [FEATURE_FLAG_NAMES.GUIDE_LIST]: false,
    [FEATURE_FLAG_NAMES.IDENTITY]: false,
    [FEATURE_FLAG_NAMES.INTEGRATIONS]: false,
    [FEATURE_FLAG_NAMES.JOURNEYS]: false,
    [FEATURE_FLAG_NAMES.LANGUAGE]: false,
    [FEATURE_FLAG_NAMES.LAYOUT_LIMITS]: false,
    [FEATURE_FLAG_NAMES.MEDIA_URL]: false,
    [FEATURE_FLAG_NAMES.MULTI_TENANCY]: false,
    [FEATURE_FLAG_NAMES.NOTIFICATIONS]: false,
    [FEATURE_FLAG_NAMES.OPEN_EDITOR]: false,
    [FEATURE_FLAG_NAMES.OVERLAY_ENCAPSULATION]: false,
    [FEATURE_FLAG_NAMES.PLAYLISTS]: false,
    [FEATURE_FLAG_NAMES.PLAYLIST_CONSOLE_ADMIN]: false,
    [FEATURE_FLAG_NAMES.PROFILE]: false,
    [FEATURE_FLAG_NAMES.PROFILE_RULES]: false,
    [FEATURE_FLAG_NAMES.PROGRESS_TRACKER]: false,
    [FEATURE_FLAG_NAMES.RECOMMENDATION]: false,
    [FEATURE_FLAG_NAMES.RECORDING]: false,
    [FEATURE_FLAG_NAMES.SEGMENTS]: false,
    [FEATURE_FLAG_NAMES.SELECTOR_SYSTEM]: false,
    [FEATURE_FLAG_NAMES.SETTINGS]: false,
    [FEATURE_FLAG_NAMES.THEME]: false,
    [FEATURE_FLAG_NAMES.THEME_BUILDER]: false,
    [FEATURE_FLAG_NAMES.TOOLTIPS]: false,
    [FEATURE_FLAG_NAMES.TOOLTIPS_2]: false,
    [FEATURE_FLAG_NAMES.TOUR]: false,
    [FEATURE_FLAG_NAMES.TRACKING]: false,
} as const;
